import { get, handleResponse } from "./base.service";
import { CONTROLLER, ACTION } from "../utilities/api.constants";

export const getDashboard = () => {
  return get(CONTROLLER.DASHBOARD + ACTION.GET).then(handleResponse);
};

export const getAnnouncementDetail = announcementId => {
  return get(
    CONTROLLER.ANNOUNCEMENT +
      ACTION.GET_DETAIL +
      "?announcementId=" +
      announcementId
  ).then(handleResponse);
};

export const isShowMemberApplication = () => {
  return get(CONTROLLER.MEMBER + ACTION.IS_SHOW_MEMBER_APPLICATION).then(handleResponse);
};